// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Cl2kb7U6ntXWpQjDeiMUY","groupsList":"_1qM7nCfwz7SAEeSR110LNe"};